import React, { FunctionComponent } from 'react';

const BrassDivFlex: FunctionComponent = () => <div style={{ flex: 1 }} />;

export { BrassDivFlex };
